import { BaseModel } from '../_base/model.class';
export class PhonebookContact extends BaseModel {
  constructor(
    private _id?: string,
    private firstName?: string,
    private lastName?: string,
    private email?: string,
    private type?: string,
    private notes?: string,
    private updatedAt?: Date,
    private createdAt?: Date,
  ) {
    super();

    this.setRequiredFields([
      '_id',
      'firstName',
      'lastName',
      'email',
      'createdAt',
    ]);
  }
}
